import { useEffect, useState } from 'react';
import { ScheduledRoute } from '../types';
import { ratesService } from '../services/rates';

export const useScheduledRoutes = () => {
  const [routes, setRoutes] = useState<ScheduledRoute[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadRoutes = async () => {
      try {
        const data = await ratesService.getAllRoutes();
        setRoutes(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('[ScheduledRoutes] Failed to load routes:', error);
      } finally {
        setIsLoading(false);
      }
    };
    loadRoutes();
  }, []);

  return { routes, setRoutes, isLoading };
};
